// This is a namespace, not a URL. See
// https://auth0.com/docs/secure/tokens/json-web-tokens/create-namespaced-custom-claims
export const NAMESPACE = 'https://unmind.com';
